import { Airports, Dates } from './recent-search.model';

export interface RecentData {
  adtCount: string;
  adtGbeCount: string;
  airports: Airports;
  awardTravel: boolean;
  chkFlexDate: boolean;
  cnnCount: any;
  dates: Dates;
  deltaOnly: string;
  departureTime: string;
  faresFor: string;
  flightHotelDeals: string;
  gbeCount: string;
  infantCount: string;
  maxPaxCount: string;
  meetingEventCode: string;
  nearbyAirports: string;
  passenger: string;
  refundableFlightsOnly: string;
  returnTime: string;
  schedulePrice: string;
  selectTripType: string;
  swapedFromCity: string;
  swapedToCity: string;
  basicFaresChecked: boolean;
}

export interface MultiCityResponse {
  cacheKey: string;
  value: {
    adtCount: string;
    adtGbeCount: string;
    airports: Airports[];
    awardTravel: boolean;
    cnnCount: any;
    dates: Dates[];
    deltaOnly: string;
    departureTime: string;
    faresFor: string;
    flightHotelDeals: string;
    gbeCount: string;
    infantCount: string;
    maxPaxCount: string;
    meetingEventCode: string;
    nearbyAirports: string;
    optionals: string;
    passenger: string;
    refundableFlightsOnly: string;
    returnTime: string;
    schedulePrice: string;
    selectTripType: string;
    swapedFromCity: string;
    swapedToCity: string;
    basicFaresChecked: boolean;
  };
}

export interface SearchSegmentData {
  fromAirportCode: string;
  fromCity: string;
  toAirportcode: string;
  toCity: string;
  departDate: string;
  returnDate: string;
  fromCountryCode?: string;
  toCountryCode?: string;
}
